import { Search, X } from 'lucide-react';
import { Button } from '@components/common/Button';
import { Input } from '@components/common/Input';
import { ScrollArea } from '@components/common/ScrollArea';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { parseDate } from '@utils/dateUtils';
import { StringUtils } from '@helpers/stringUtils';
import { MdOutlineNoMeetingRoom } from 'react-icons/md';
import { LuCalendarCheck2 } from 'react-icons/lu';

export const InterviewLists = ({
    filteredCandidates,
    search,
    setSearch,
    dateRange,
    clearFilters,
}) => {
    return (
        <div className="bg-slate-100 rounded-lg  p-4">
            <h2 className="font-medium mb-4">Interview List:</h2>

            {filteredCandidates.length > 0 ? (
                <>
                    <div className="flex gap-2 mb-6">
                        <div className="relative flex-1">
                            <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
                            <Input
                                placeholder="Search Interview"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                className="pl-9 !border-none bg-white"
                            />
                        </div>
                        {(dateRange || search) && (
                            <Button variant="ghost" onClick={clearFilters} size="icon">
                                <X className="h-4 w-4" />
                            </Button>
                        )}
                    </div>
                    <ScrollArea className="h-[300px]">
                        <div className="space-y-3">
                            {filteredCandidates.map(candidate => (
                                <CandidateCard key={candidate.id} candidate={candidate} />
                            ))}
                        </div>
                    </ScrollArea>
                </>
            ) : (
                <div className="flex justify-center items-center h-[300px]">
                    <div className="flex flex-col items-center gap-2 ">
                        <MdOutlineNoMeetingRoom className="text-4xl text-gray-500" />
                        <p className="text-sm text-gray-500">No Interview Scheduled</p>
                    </div>
                </div>
            )}
        </div>
    );
};

InterviewLists.propTypes = {
    filteredCandidates: PropTypes.array.isRequired,
    search: PropTypes.string.isRequired,
    setSearch: PropTypes.func.isRequired,
    dateRange: PropTypes.object,
    clearFilters: PropTypes.func.isRequired,
};

const CandidateCard = ({ candidate }) => {
    const candidateDate = parseDate(candidate.interview_scheduled_at);

    return (
        <div className="flex items-center justify-between p-4 border rounded-lg bg-white transition-colors ">
            <div className="space-y-1">
                <div className="flex items-center gap-2 text-xs text-gray-500">
                    <div className="flex items-center gap-2">
                        <LuCalendarCheck2 className="text-primary-blue text-md" />
                        {format(candidateDate, 'HH:mm dd.MM.yyyy')}
                    </div>

                    <div>
                        Interview with &nbsp;
                        <span className="font-medium">{candidate?.candidate_name || ''}</span> (
                        {candidate.job_title})
                    </div>
                </div>
                {StringUtils.isNull(candidateDate) && (
                    <p className="text-xs text-red-500">No Interview Scheduled</p>
                )}
            </div>
        </div>
    );
};

CandidateCard.propTypes = {
    candidate: PropTypes.object.isRequired,
};
